var stickyHelper = $('<div>').addClass('sticky-wrapper');

function _process($stickyTarget, scrollElement) {
    var scrollTop;
    if(scrollElement) {
        scrollTop = $(scrollElement).scrollTop();
    } else {
        scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    }

    var stickyHeight = $stickyTarget.outerHeight();
    var stickyTop = stickyHelper.offset().top;
    if (scrollTop >= stickyTop){
        stickyHelper.height(stickyHeight);
        $stickyTarget.addClass('pos-f-t');
    } else {
        $stickyTarget.removeClass('pos-f-t');
        stickyHelper.height('auto');
    }
}

function setStickyTo(target, scrollElement) {
    var $stickyTarget = $(target);
    $stickyTarget.before(stickyHelper);
    $stickyTarget.addClass('sticky');
    _process($stickyTarget, scrollElement);
    $(window).on('scroll.sticky-on-scroll', function() {
        _process($stickyTarget, scrollElement);
    });
}

module.exports = setStickyTo;



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/sticky/sticky.js
// module id = 50
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14